import { Injectable } from '@angular/core';

import { from, Observable, ObservableInput, ObservedValueOf, Subject } from 'rxjs';
import * as moment from "moment-timezone";
import { BlueprintContent } from '../modules/assets/asset-blueprint/asset-blueprint-content';
import { BlueprintContentCIC } from '../modules/assets/asset-blueprint/asset-blueprint-content-cic';
import { DataBroadcastModel } from 'src/app/model';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  events: Observable<ObservedValueOf<ObservableInput<any>>>;
  private subject = new Subject<DataBroadcastModel>();

  constructor() {
    this.events = from(this.subject);
  }

  broadcast(name: string, ...args: any) {
    this.subject.next({
      name,
      args
    });
  }

  setTimeZone(timeZone: string) {
    sessionStorage.setItem('selectedTimeZone', timeZone);
  }

  convertToTimeZone(time: any) {
    let timezoneFull;
    const timezone = sessionStorage.getItem('selectedTimeZone');
    if (timezone) {
      timezoneFull = moment(time).tz(timezone)?.format('YYYY-MM-DDTHH:mm:ssZZ');
    } else {
      timezoneFull = time;
    }
    return timezoneFull;
  }

  findgmtOffset(timeZoneName) {
    return 'GMT' + moment.tz(timeZoneName).format('Z')?.toString();
  }

  /**
   * Gets blueprint content
   * @returns  
   */
  getBlueprintContent(tenantGenericConfig) {
    if (tenantGenericConfig?.tenant === 'CIC') {
      return BlueprintContentCIC;
    } else {
      return BlueprintContent;
    }
  }
}
